import { prepareHeaders } from "./";
import cincolabdataEndpoints from "./cincolabdata.endpoints";

import type { LocalizedField } from "./types";

export interface EventDay {
  start_time: string;
  end_time: string;
}

export interface EventLocation {
  lat: string;
  lng: string;
  address: string;
}

export interface EventBooking {
  name: string;
  image_url: string;
  booking_url: string;
}

export interface Event {
  key: string;
  name: LocalizedField;
  city: LocalizedField;
  province: string;
  start_date: string;
  end_time: string;
  instance_key: string;
  days: EventDay[];
  location: EventLocation;
  bookings: EventBooking[];
}

/**
 * Fetches all events
 * @returns Returns a promise that resolves with all events
 */
export const getEvents = async (): Promise<Event[]> => {
  const { status, body } = await fetch(
    cincolabdataEndpoints.public.events("FORD_MODEL_E_DIGITAL_ACTIVATION"),
    {
      method: "GET",
      headers: prepareHeaders(),
      mode: "cors",
      redirect: "follow",
    },
  )
    .then(async (response) => {
      const data = await response.json();
      return { status: response.status, body: data };
    })
    .catch((error) => {
      console.log("Error fetching events:", error);
      throw error;
    });

  if (status !== 200) {
    return [];
  }

  return body;
};

/**
 * Fetches the next or current event for a given province
 * @param province
 * @returns Returns a promise that resolves with the next or current event
 */
export const getNextOrCurrentEvent = async (
  province: string,
): Promise<Event | null> => {
  const events = await getEvents();
  const now = new Date().getTime();

  // Find the next event for the given province
  const nextEvent = events
    .filter(({ province: eventProvince }) => eventProvince === province)
    .find(({ end_time }) => {
      // Check if the event end time is greater than the current time
      const eventEndTime = new Date(end_time).getTime();
      return eventEndTime > now;
    });

  return nextEvent || null;
};
